<div class="maintenance">
    <div class="card">
        <h1 style="text-align: center;">Website is under Maintenance</h1>
        <h4 style="text-align: center; color: #fcbf06;">Will be back </h4>
        <!-- <h4 class="countdown">{{date}}</h4> -->
        <h4 class="countdown">2026-02-25</h4>

        <img src="/assets/images/maintenance.png" alt="Maintenance">
    </div>
</div>